<style>

.tabCat .select_container {
    display: none;
}
.middle .tabCat .select_container {
    display: block;
    margin-top: 0px;
}
.tabCat .active{
border: 1px solid #FF0000;
    box-sizing: border-box;
    border-radius: 5px;
}
.tabCat {
    display: flex;
    flex-direction: column;
}
.select_container {
    --border: 1px solid #E5E5E5;
    --placeholderColor: #f00;
    --itemActiveBackground: #ffe7e7;
    --itemIsActiveBG: #ffe7e7;
    --itemIsActiveColor: #000;
    --itemHoverBG: #ffe7e7;
    --borderFocusColor: #E5E5E5;
    --background: #0000;
    --itemPadding: 0, 10px;
    --padding: 0, 10px;
    --selectedItemPadding: 0 30px 0 0;
}
.tabCat .select_container {
    display: none;
}
.middle .tabCat .select_container {
    display: block;
    position: relative;
}
.middle button.tablinksCat1 {
    display: none;
}
button.tablinksCat1{
    width: 313px;
    height: 46px;
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    text-align: center;
    justify-content: left;
    align-content: flex-start;
    align-items: center;
    background: #fff;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    font-family: Gotham Pro, sans-serif;
    color: #404455;
    margin-top: 11px;
    cursor: pointer;
}
img.tab_image {
    width: 24px;
    height: 24px;
    padding-right: 0.4em;
    object-fit: contain;
}
.tabcontent{
    display: flex;
    margin-top: 80px;
}

.tabcontent.middle  {
    flex-direction: column;
    /*min-width: 300px;*/
    margin-top: 10px;
}
</style>
<script>
    import Select from 'svelte-select';
    import CategoryTabContent from './CategoryTabContent.svelte';

    import { mutations, tabImagesArray, responsiveClass, goodsList, selectedPlusItem, track } from '../../../mainStore.js';
    import config from '../../../config.js';

    import helper from '../../../helper.js';

    export let categories = []
    export let items = []
    export let index = 0
    let itemsObj = {}
    let categoriesArr = []

    function openCategoryTab(val) {
        index = val
    }
    function handleSelect(val, hh) {
        index = categoriesArr.findIndex((r)=>{return r.name == val.detail.name})
    }
    function getSelectionLabel(option) {
        return "<div style='display: flex;align-items: center;padding: 0 10px;'><img style='width: 32px;height: 32px;object-fit: contain;margin-right:6px;' src='" + getTabImage(categoriesArr[index].image) + "' alt=''>" + option.name + "</div>"
    }
    function getOptionLabel(option) {
        return "<div style='display: flex;align-items: center;padding: 0 10px;'><img style='width: 32px;height: 32px;object-fit: contain;margin-right:6px;' src='" + getTabImage(option.image) + "' alt=''>" + option.name + "</div>"
    }

    function getDummy(){
        return "/build/images/No Image.png"
    }

    function getTabImage(src) {
        if(src){
            return src
        } else {
            return getDummy()
        }
    }
    function enable(item) {
        let lvl = "bottom"
        if ($selectedPlusItem) {
            if ($selectedPlusItem.onTop) {
                lvl = "top"
            }
            let exceptionSum = 0
            for (let exception of item["exception_place_" + $selectedPlusItem.position + "_" + lvl]) {
                exceptionSum += exception.x2 - exception.x1
            }
            return exceptionSum <= $track["width_" + $selectedPlusItem.position]
        }
        return true
    }

    function setItemsObj(itemsArr, inputCategoriesArr) {
        let newCategoriesArr = []
        let newItemsObj = {}
        for (let category of inputCategoriesArr) {
            for (let item of itemsArr) {
                if (category.id == item.category_id) {
                    if (!helper.checkDisabled(item, $goodsList) && enable(item)) {
                        if (typeof newItemsObj[category.id] == "undefined") {
                            newItemsObj[category.id] = []
                            newCategoriesArr.push(category)
                        }
                        newItemsObj[category.id].push(item)
                    }
                }
            }
        }
        itemsObj = newItemsObj
        categoriesArr = newCategoriesArr
    }

    $: setItemsObj(items, categories)
    $: tabNameCategory = typeof categoriesArr[index] == 'undefined'?  null : categoriesArr[index].name

</script>

<div class="tabcontent {$responsiveClass}">
    <div class="tabCat">
        <div class="select_container">
            <Select on:select="{handleSelect}" isSearchable={false} getSelectionLabel={getSelectionLabel} getOptionLabel={getOptionLabel} optionIdentifier="name" items={categoriesArr} isClearable={false} selectedValue="{tabNameCategory}" noOptionsMessage="Нет категорий" placeholder=" Нечего выбирать в эту зону"></Select>
        </div>
    </div>
    {#if (categoriesArr[index] && itemsObj[categoriesArr[index].id])}
        <CategoryTabContent items={itemsObj[categoriesArr[index].id]} />
    {/if}
</div>
